/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useState} from 'react';
import { withRouter } from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Grid, Card, CardContent} from "@material-ui/core";
import {Alert} from "@material-ui/lab";

import LoginShareFormComponent from '../../components/Forms/LoginShareFormComponent';
import {useThemeData} from '../../context/ThemeDataContext'
import GeneralButton from "../../components/Buttons";

function PhotoLoginShare(props) {
    const {
        font_family,
        primary_color_2,
    } = useThemeData().themeData.site.theme;
    const [completed, setCompleted] = useState(false);

    const goBackHome = () => {
        let location = {
            pathname: `/shoppage/photo_id/${localStorage.getItem("photo_id")}`
        }
        props.history.push(location);
    }

    return (
        <Grid lg={12} md={6} style={{
            fontFamily: `${font_family}`,
            color: `${primary_color_2}`
        }}>
            <Card style={{
                fontFamily: `${font_family}`,
                color: `${primary_color_2}`
            }}>
            <CardContent className="contact-text">
                {/*<Card className="loginscreen-fields" body>*/}
                    {completed ?
                        // message is send
                        <>
                            <Alert variant="success">{props.t('Success')}</Alert>

                            <Grid container direction="row">
                                <GeneralButton
                                    onClick={goBackHome}
                                    className="btn btn-light btn-margin">
                                    {props.t('Back to the Shop')}
                                </GeneralButton>
                            </Grid>


                        </>
                        :
                        <LoginShareFormComponent {...props} setCompleted={setCompleted}/>
                    }
                {/*</Card>*/}
            </CardContent>
            </Card>
        </Grid>
    );
}

export default React.memo(withRouter(withTranslation('photoLoginShare')(PhotoLoginShare)));
